import React, { Suspense } from 'react';

const MarkdownImpl = React.lazy(() => import('components/common/markdown-impl'));

export type MarkdownProps = {
  markdown: string;
  className?: string;
  dataE2e?: string;
};

const Markdown: React.FunctionComponent<MarkdownProps> = props => (
  <Suspense fallback={null}>
    <MarkdownImpl {...props} />
  </Suspense>
);

export default Markdown;
